module.exports = "/templates/targettemplate.html";


//////////////////
// WEBPACK FOOTER
// ./src/templates/targettemplate.html
// module id = 464
// module chunks = 0